import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import AddRoleForm from 'components/widgets/forms/addRoles/AddRoleFormContainer';
import { ModalContext } from "context/ModalContext";
import AddClientQuotationForm from "../forms/AddClientQuotation";

const AddClientQuotation = (props) => {

  return (
       
          <Modal
          show={props.show} 
          onHide={props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="text-grey">Add Client Quotation</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <AddClientQuotationForm refetch={props.refetch}/>
            </Modal.Body>
          </Modal>
        
   
  );
};

export default AddClientQuotation;
